import React, { Component, Fragment } from 'react';
import RoleRow from './RoleRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Link } from 'react-router-dom';
import SearchFilter from '../Reusable/SearchFilter';
import ModalForAddRole from './ModalForAddRole';
import withTranslations from '../../utils/HighOrderComponent';

class RoleTable extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
  }

  showModal = (e) => {
    this.setState({
      show: true,
    });
  };

  handlePreviewClose = () => {
    this.setState({ show: false });
    this.props.deleteError();
  };

  handleAdd = (role) => {
    this.props.createRoleAndReturnRoleDTO(role, this.handlePreviewClose);
  };

  isModalOpened = () => {
    this.props.isModalOpened(this.state.show);
  };

  render() {
    const { t } = this.props || {},
      { HeaderColumns, titleTable } = t || {};

    const roleList = this.props.roleList?.map((role, index) => (
      <RoleRow
        index={index + 1}
        key={role.id}
        role={role}
        deleteRole={this.props.deleteRole}
        updateRole={this.props.updateRole}
        actionList={this.props.actionList}
        deleteError={this.props.deleteError}
        error={this.props.error}
        setMessage={this.props.setMessage}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={2} />
                </Col>
                <Col className="addUser col-md-1">
                  <Link id="addUser" onClick={() => this.showModal()}>
                    <i className="fas fa-plus fa-2x" />
                  </Link>
                </Col>
              </Row>
            </Card.Header>

            <Table responsive hover id="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{HeaderColumns.roleName}</th>
                  <th className="text-center">{HeaderColumns.actions}</th>
                  <th className="text-center">{HeaderColumns.delete}</th>
                </tr>
              </thead>
              <tbody>{roleList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.show && (
          <ModalForAddRole
            handleAdd={this.handleAdd}
            handleClose={this.handlePreviewClose}
            show={this.state.show}
            actionList={this.props.actionList}
            error={this.props.error}
            deleteError={this.props.deleteError}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(RoleTable, 'RoleTable');
